// ABOUTME: Relation orders overview — an inline dashboard: the layout a saved dashboard has, except every cell
// ABOUTME: carries the report it draws, so DashboardViewer renders it without anything saved in the report hub.
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import DashboardViewer from "../../../../components/global/StockhubBI/DashboardViewer";

const LAST_30_DAYS = { type: "relative", days: 30, frame: "1D", custom: false };

const ordersOverviewDashboard = (t) => ({
    name: `${t('orders_last_30_days')}`,
    dashboard: {
        sections: [
            {
                id: "orders-overview-section",
                type: "section",
                children: [
                    {
                        id: "orders-overview-total-row",
                        type: "row",
                        totalWidth: 1,
                        children: [
                            {
                                id: "orders-overview-total",
                                type: "column",
                                width: 1,
                                chart: {
                                    kind: "chart",
                                    name: t("orders"),
                                    type: "orders",
                                    displayType: "line",
                                    report: {
                                        reportType: "withchart",
                                        type: "orders",
                                        date: { type: "relative", days: 30, frame: "1D" },
                                        filter: {},
                                        category: { use: false },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        id: "orders-overview-breakdown-row",
                        type: "row",
                        totalWidth: 2,
                        children: [
                            {
                                id: "orders-overview-channels",
                                type: "column",
                                width: 1,
                                chart: {
                                    kind: "chart",
                                    name: `${t("orders")} / ${t("channels")}`,
                                    type: "orders",
                                    displayType: "bar",
                                    report: {
                                        reportType: "withchart",
                                        type: "orders",
                                        date: LAST_30_DAYS,
                                        filter: {},
                                        category: { use: true, key: "webshopcredentials", values: [], all: true },
                                    },
                                },
                            },
                            {
                                id: "orders-overview-countries",
                                type: "column",
                                width: 1,
                                chart: {
                                    kind: "chart",
                                    name: `${t("orders")} / ${t("countries")}`,
                                    type: "orders",
                                    displayType: "bar",
                                    report: {
                                        reportType: "withchart",
                                        type: "orders",
                                        date: LAST_30_DAYS,
                                        filter: {},
                                        // Countries only earn a bar when they actually occur in the period.
                                        category: { use: true, key: "countries", values: [], all: true, allBehavior: "present" },
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        ],
        tabBody: null,
    },
});

const OrdersOverview = () => {
    const { t, i18n } = useTranslation();
    // The viewer posts this config to have its cells computed, so it has to keep the same identity between
    // renders — a fresh object every render would refetch on every render.
    const config = useMemo(() => ordersOverviewDashboard(t), [t, i18n.language]);

    return <DashboardViewer config={config} hideControls />;
};

export default OrdersOverview;
